export const breakpoints = {
 base: '0px',
 xs: '362px',
 sm: '450px',
 md: '768px',
 lg: '1000px',
 xl: '1200px',
 xxl: '1500px',
};